import { SettingsEndpoint } from '@constants/ApiEndpoints';
import { AxiosInstance } from 'axios';
import { CashierListItemModel, CashierModel } from 'models/Settings/Financial/Cashier';

import { FetchingRequestParamsModels } from 'models/Shared/FetchingRequestParamsModels';

export interface Options {
  id: number;
  label: string;
}

export interface TypeModel {
  id: string | undefined;
  value: string | number;
  label: string;
}

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<CashierModel> => {
    return await axios.delete(`${SettingsEndpoint.SETTINGS_FINANCIAL_CASHIER}/${id}`);
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<{ items: CashierListItemModel[]; total: number }> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_FINANCIAL_CASHIER, {
        params,
      })
      .then(({ data }) => {
        return data;
      });
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: CashierModel): Promise<CashierModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_FINANCIAL_CASHIER, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: CashierModel): Promise<CashierModel> => {
    return await axios
      .put(`/${SettingsEndpoint.SETTINGS_FINANCIAL_CASHIER}/${data.id}`, data)
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<CashierModel> => {
    return await axios
      .patch(`/${SettingsEndpoint.SETTINGS_FINANCIAL_CASHIER}/${id}`)
      .then(({ data }) => data);
  };

export const users =
  (axios: AxiosInstance) =>
  async (params?: FetchingRequestParamsModels): Promise<Array<{ id: number; name: string }>> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_FINANCIAL_CASHIER_USERS, {
        params,
      })
      .then(({ data }) => {
        return data;
      });
  };
